var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBhandarilogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 182,
    viewBox: "0 0 182 182",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2619_1327)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.742 120.917C114.576 123.143 119.168 127.08 132.357 130.786C152.996 135.574 164.755 134.608 171.46 131.752C173.246 128.266 174.812 124.644 176.136 120.917H103.752H103.742Z",
    fill: "url(#paint0_linear_2619_1327)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2396 127.919C31.4107 114.764 9.93095 129.925 9.93095 129.925L7.24072 131.542C9.89942 136.812 13.0625 141.768 16.646 146.387C49.7694 125.337 96.7537 143.059 103.574 144.665C108.933 145.925 136.739 154.062 151.094 158.293C156.475 153.442 161.277 147.962 165.375 141.978C142.204 144.077 107.851 135.416 83.2396 127.93V127.919Z",
    fill: "url(#paint1_linear_2619_1327)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4043 153.097C27.0807 158.063 32.3035 162.493 37.9992 166.315C61.6963 153.569 99.3384 164.94 106.442 167.68C110.141 169.118 118.054 171.795 126.009 174.431H126.02C132.294 171.722 138.189 168.32 143.643 164.331C123.719 161.265 97.4258 154.01 69.788 147.081C47.2679 141.296 32.0197 146.461 22.4148 153.086L22.4043 153.097Z",
    fill: "url(#paint2_linear_2619_1327)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7305 171.984V172.057C60.2463 178.409 74.412 182 89.4079 182C99.3176 182 108.881 180.435 117.823 177.527C84.5634 165.117 47.7305 171.984 47.7305 171.984Z",
    fill: "url(#paint3_linear_2619_1327)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9409 49.1775C34.7732 63.7186 34.8258 75.7925 34.4159 81.252C36.854 82.4068 39.2079 83.7192 41.4778 85.1576C41.4988 85.1786 41.5198 85.1786 41.5408 85.1996C44.105 86.8374 46.585 88.6537 48.939 90.659C49.1701 90.8585 49.3908 91.0685 49.622 91.2785C55.8327 82.2074 71.6693 53.7971 69.8197 2.45703C64.2501 3.7904 58.8697 5.62773 53.7519 7.927C51.2404 29.8804 35.4563 44.1485 28.9514 49.167L28.9409 49.1775Z",
    fill: "url(#paint4_linear_2619_1327)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6182 49.8598C20.4606 49.5868 20.345 49.3033 20.2504 49.0198C18.9368 46.1431 17.371 43.1719 15.49 40.1377C8.66984 50.2482 3.82533 61.7971 1.52393 74.2489C10.5824 74.3014 18.9683 75.5823 26.6187 78.123C26.7448 72.3591 25.9671 62.0071 20.6182 49.8598Z",
    fill: "url(#paint5_linear_2619_1327)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9666 12.4727C35.6349 17.9531 27.3751 25.0294 20.5654 33.3446C22.4675 36.2109 24.1279 39.0456 25.5571 41.8173C31.1477 37.3448 41.4672 27.3602 44.9666 12.4832V12.4727Z",
    fill: "url(#paint6_linear_2619_1327)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.967 4.70396C114.702 2.94013 109.227 1.63825 103.574 0.861328C106.127 14.594 107.357 26.9828 107.578 38.1432C112.821 31.7494 119.4 20.6099 119.967 4.70396Z",
    fill: "url(#paint7_linear_2619_1327)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.142 76.349C166.489 74.8686 173.267 74.1547 180.466 74.2177C178.563 63.9706 174.938 54.3221 169.904 45.5869C158.387 55.9284 159.017 69.7976 160.142 76.349Z",
    fill: "url(#paint8_linear_2619_1327)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9954 89.9767C24.422 84.7167 13.1882 82.1129 0.409605 82.1759C0.136379 85.0526 -0.0107422 87.9714 -0.0107422 90.9216C-0.0107422 97.7984 0.756392 104.497 2.20659 110.933C21.3324 107.321 30.5695 95.6251 33.9849 89.9872L33.9954 89.9767Z",
    fill: "url(#paint9_linear_2619_1327)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.477 103.016C165.564 104.486 159.301 109.357 155.381 113.242C161.624 114.365 168.128 116.224 174.528 119.132H177.523C179.247 113.872 180.497 108.392 181.222 102.754C178.616 102.449 176.031 102.533 173.467 103.016H173.477Z",
    fill: "url(#paint10_linear_2619_1327)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.579 82.1757C163.536 81.8082 148.509 86.6587 136.802 96.6958C131.358 101.357 126.966 106.859 123.403 112.686C128.973 111.93 136.854 111.342 145.776 112.014C149.213 107.72 158.439 97.7562 171.953 95.2154C175.264 94.5855 178.595 94.47 181.916 94.8269C181.979 93.5356 182 92.2232 182 90.9108C182 87.9711 181.853 85.0524 181.579 82.1757Z",
    fill: "url(#paint11_linear_2619_1327)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9016 80.0963L56.3896 86.6477C55.2441 87.5296 55.034 89.1674 55.9167 90.3118C56.7364 91.3827 58.2076 91.6347 59.332 90.9523C59.4161 90.8998 59.5002 90.8368 59.5842 90.7843L61.6019 89.2304L62.4531 88.569L65.2589 86.4062V119.121H70.2611V82.5636L73.172 80.3273L90.6584 66.8676L111.781 83.12V119.121H116.783V86.9626L117.949 87.8551L118.548 88.317L120.566 89.8709L121.743 90.7738C122.216 91.1412 122.783 91.3092 123.33 91.3092C124.118 91.3092 124.885 90.9628 125.4 90.2908C125.579 90.0703 125.705 89.8289 125.789 89.5769C125.789 89.5769 125.789 89.5769 125.789 89.5664C125.768 91.9917 125.831 94.186 125.947 96.1178C127.723 94.2174 129.593 92.3906 131.621 90.6583C137.821 85.3458 144.799 81.3142 152.513 78.5739C151.083 70.5737 149.864 51.8855 165.554 38.7618C162.002 33.7013 157.946 29.0187 153.458 24.7876C131.096 45.8906 126.23 71.4136 125.81 87.918C125.81 87.918 125.81 87.9076 125.81 87.8971C125.663 87.4036 125.358 86.9626 124.917 86.6267L118.296 81.5242C119.81 63.8439 126.304 39.8432 147.447 19.5801C141.457 14.8556 134.868 10.8555 127.807 7.72677C126.01 31.528 112.243 45.4916 107.43 49.6807C107.073 57.5445 106.19 64.7153 104.919 71.2352L97.6572 65.6497C100.368 48.9563 100.589 27.3809 95.3453 0.0835055C93.9056 0.0100126 92.4554 -0.0214844 91.0052 -0.0214844C86.497 -0.0214844 82.0518 0.303984 77.7222 0.944423C79.309 38.3103 71.9845 64.1903 64.9121 80.0753L64.9016 80.0963ZM91.0683 60.9461C91.0683 60.9461 91.1523 61.0091 91.1944 61.0301C91.1313 61.0196 91.0683 61.0091 90.9947 60.9986C91.0157 60.9776 91.0367 60.9671 91.0578 60.9461H91.0683Z",
    fill: "url(#paint12_linear_2619_1327)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6925 113.599C54.0355 107.415 49.4747 101.577 43.737 96.6743C42.7281 95.8029 41.6878 94.9945 40.6264 94.207C36.2863 101.063 25.3993 114.239 4.27686 118.523C4.33991 118.733 4.40296 118.932 4.47652 119.132H55.286C56.4525 116.79 57.2301 114.848 57.703 113.599H57.6925Z",
    fill: "url(#paint13_linear_2619_1327)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.593 96.5907C104.656 96.2443 104.572 95.8873 104.362 95.6038C104.152 95.3204 103.836 95.1314 103.49 95.0894C103.448 95.0894 102.985 95.0264 102.26 95.0264C100.484 95.0264 96.7325 95.3939 94.1999 98.2391C92.9073 94.407 89.7232 89.9449 83.3023 89.3779C82.7033 89.3149 82.1464 89.6929 81.9572 90.2704C81.8837 90.5013 80.1497 96.0868 83.0186 101.032C84.5949 103.751 87.2221 105.704 90.8371 106.859C88.2204 110.953 88.5672 116.255 89.2187 119.731H91.8564C91.6357 118.628 91.4151 117.274 91.352 115.835C91.8774 116.077 92.7181 116.371 93.7585 116.371C94.5887 116.371 95.608 116.182 96.7009 115.552C97.7938 114.922 98.9603 113.862 100.064 112.098C100.432 111.51 100.263 110.733 99.6959 110.344C99.5593 110.25 98.2772 109.421 96.4908 109.421C95.1246 109.421 93.2751 109.924 91.5727 112.014C91.8774 110.344 92.508 108.728 93.6219 107.373C95.0931 107.058 103.174 104.969 104.572 96.5697L104.593 96.5907Z",
    fill: "url(#paint14_linear_2619_1327)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2619_1327",
    x1: 68.5691,
    y1: -41.4289,
    x2: 147.86,
    y2: 139.292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8DD2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F944B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2619_1327",
    x1: 17.7704,
    y1: -19.1505,
    x2: 97.0722,
    y2: 161.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8DD2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F944B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2619_1327",
    x1: 6.925,
    y1: -14.3832,
    x2: 86.2163,
    y2: 166.337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8DD2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F944B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2619_1327",
    x1: 0.798663,
    y1: -11.6964,
    x2: 80.1006,
    y2: 169.024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8DD2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F944B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2619_1327",
    x1: 24.0859,
    y1: -21.9111,
    x2: 103.377,
    y2: 158.809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8DD2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F944B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2619_1327",
    x1: -17.77,
    y1: -3.54861,
    x2: 61.5318,
    y2: 177.172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8DD2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F944B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2619_1327",
    x1: 14.8487,
    y1: -17.8589,
    x2: 94.14,
    y2: 162.862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8DD2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F944B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2619_1327",
    x1: 83.3025,
    y1: -47.896,
    x2: 162.604,
    y2: 132.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8DD2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F944B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2619_1327",
    x1: 111.938,
    y1: -60.4634,
    x2: 191.23,
    y2: 120.268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8DD2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F944B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2619_1327",
    x1: -26.0197,
    y1: 0.0633024,
    x2: 53.2821,
    y2: 180.794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8DD2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F944B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2619_1327",
    x1: 97.1212,
    y1: -53.9544,
    x2: 176.412,
    y2: 126.766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8DD2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F944B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2619_1327",
    x1: 87.7473,
    y1: -49.8492,
    x2: 167.049,
    y2: 130.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8DD2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F944B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2619_1327",
    x1: 63.4724,
    y1: -39.1932,
    x2: 142.774,
    y2: 141.527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8DD2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F944B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2619_1327",
    x1: -21.007,
    y1: -2.1317,
    x2: 58.2842,
    y2: 178.599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8DD2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F944B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2619_1327",
    x1: 37.2848,
    y1: -27.7173,
    x2: 116.576,
    y2: 153.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8DD2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F944B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2619_1327"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 182,
    height: 182,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBhandarilogo);
export default __webpack_public_path__ + "static/media/bhandarilogo.210b9d4b43fdaf4ca8cab0bab843e40c.svg";
export { ForwardRef as ReactComponent };